class articleSlider extends HTMLElement {
  constructor() {
    super();

    let bannerSwiper = new Swiper(this.querySelector('[data-blog-slider]'), {
      slidesPerView: 1.2,
      loop: true,
      effect: 'slide',
      loop: false,
      speed: 1000,
      navigation: {
        nextEl: this.querySelector('.hero__button-next'),
        prevEl: this.querySelector('.hero__button-prev')
      },
        breakpoints: {
    768: {
      slidesPerView: 3,
    }
  },
    });
  }
}
customElements.define('blog-article-slider', articleSlider);
